import { render, staticRenderFns } from "./newfeespayments.vue?vue&type=template&id=ad475a9a&"
import script from "./newfeespayments.vue?vue&type=script&lang=js&"
export * from "./newfeespayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports